export class FiltrosEventos {
  nomeEvento: string;
  idTipo: number;

  constructor() {
    this.limpar();
  }

  limpar(): void {
    this.nomeEvento = "";
    this.idTipo = 0;
  }

  toFormData(): FormData {
    const data = new FormData();
    if (this.nomeEvento) data.append("filtroNomeEvento", this.nomeEvento);
    if (this.idTipo > 0)
      data.append("filtroTipoEvento", String(this.idTipo));
    
    return data;
  }

  toQueryString(): string {
    let retorno = "";
    if (this.nomeEvento) retorno += "&filtroNomeEvento=" + this.nomeEvento;
    if (this.idTipo > 0)
      retorno += "&filtroTipoEvento=" + String(this.idTipo);

    return retorno;
  }
}
